import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/header/Header";
import { ValuationUDA } from "./pages/valuationUda/valuationUDA.pages";
import { DataRequest } from "./pages/dataRequest/dataRequest.pages";
import { ActiveProfiling } from "./pages/activeProfiling/activeProfiling.pages";
import { SuccessScreen } from "./pages/success/successScreen.pages";
import { Search } from "./pages/search/search.pages";
import { Footer } from "./components/footer/footer.component";
import banner from "./assets/Frame1.webp";
import "react-toastify/dist/ReactToastify.css";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export const MainContainer = ({
    children,
    backgroundImage,
    showHeader,
    showFooter,
}) => {
    return (
        <div className="main-div">
            {backgroundImage && (
                <div
                    className="flex flex-col h-screen justify-between"
                    style={{
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        flex: 1,
                        width: "100%",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        zIndex: -1,
                    }}
                ></div>
            )}
            {showHeader && <Header />}
            {children}
            {showFooter && <Footer />}
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route
                    path="/"
                    element={
                        <MainContainer
                            backgroundImage={banner}
                            showHeader={true}
                            showFooter={false}
                        >
                            <Search />
                        </MainContainer>
                    }
                />
                <Route
                    path="/active"
                    element={
                        <MainContainer showHeader={true} showFooter={false}>
                            <ActiveProfiling />
                        </MainContainer>
                    }
                />
                <Route
                    path="/dataRequest"
                    element={
                        <MainContainer showHeader={true} showFooter={false}>
                            <DataRequest />
                        </MainContainer>
                    }
                />
                <Route
                    path="/successScreen"
                    element={
                        <MainContainer showHeader={true} showFooter={false}>
                            <SuccessScreen />
                        </MainContainer>
                    }
                />
                <Route
                    path="/modelUDA"
                    element={
                        <MainContainer showHeader={false} showFooter={false}>
                            <ValuationUDA />
                        </MainContainer>
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
